import { APP_BASE_URL } from "@config";

export type TopNavRoute = {
  title: string;
  route: string;
  key: string;
};

export const getTopNavRoutes = (t: (key: string) => string): TopNavRoute[] => [
  { title: t("Home"), route: `${APP_BASE_URL}/#home`, key: "home-link-item" },
  { title: t("Calendar"), route: `${APP_BASE_URL}/#calendar`, key: "calendar-link-item" },
  { title: t("Dashboard"), route: `${APP_BASE_URL}/#dashboard`, key: "dashboard-link-item" },
  { title: t("ATP"), route: `${APP_BASE_URL}/#plan`, key: "atp-link-item" },
];
